import type { InstructionKey } from "../return-shipping-instructions/instructions";

/**
 * Default title font size (px). Shared by the renderer (`email.tsx` TITLE_STYLE)
 * and the panel editor's paragraph base style so the WYSIWYG editor matches the
 * rendered output — keep them derived from this single source.
 */
export const TITLE_FONT_SIZE_PX = 18;

/**
 * Default title for a given instruction key. There are only two titles: the
 * logistic return slip (`bonDeRetour`) and the shipping-label title for every
 * carrier case. Returns the tLayout key + English fallback (tLayout has no
 * per-key fallback), mirroring the message block's resolution.
 */
export function getTitleDefault(key: InstructionKey): {
  tLayoutKey: string;
  fallback: string;
} {
  if (key === "bonDeRetour") {
    return {
      tLayoutKey: "shippingInstructionsTitle.bonDeRetour",
      fallback: "Your return slip is ready",
    };
  }
  return {
    tLayoutKey: "shippingInstructionsTitle.shippingLabel",
    fallback: "Your shipping label is ready",
  };
}
